// ============================================================================
// KASAI ALGORITHM - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'kasai-algorithm',
  name: 'Kasai Algorithm',
  category: 'Strings',
  complexity: {
    time: 'O(N)',
    space: 'O(N)'
  },
  description: 'An efficient algorithm for computing the Longest Common Prefix (LCP) array from a suffix array. It uses the previously computed LCP values to compute subsequent values in linear time.'
};
